export default "__VITE_PUBLIC_ASSET__f91d101c__"